import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/brands.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { Link } from "react-router-dom";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import TextArea from "../../../components/form/TextArea";
import DropDown from "../../../components/form/DropDown";
import AvatarUploade from "../../../components/form/AvatarUploade";
import { BrandModel } from "../models/BrandModel";
import { DrawerForm } from "../../../components/drawers/DrawerForm";

export default function BrandsListView() {

  const hub = useHub()
  const user = getUser()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>(true)

  const [selectedItem, selectedItemSet] = useState<BrandModel>()


  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteBrand = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: BrandModel) => (
    <FlexRow onClick={() => edit(data)}>
      <div className="">
        <img src={data.logoUrl} className="w-50px w-xxxl-75px" />
      </div>
      <div className="ms-2">
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const VendorItem = (data: BrandModel) => (
    <FlexRow>
      <div className="ms-2">
        {data.vendor?.name}
      </div>
    </FlexRow>
  )


  const CreatedItem = (data: BrandModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: BrandModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageBrands");
    setPage("Brands", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Brand"
          apiRoute={API_ROUTES.InventoryBrands}
          filteringProps={filteringProps}
          // sortingProps={sortingProps}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteBrands")} deleteCustom={deleteBrand}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Vendor">
            <VendorItem />
          </DataTableField>

          <DataTableField title="Description" dataValueName="description" />

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        (createModal || editModal) &&
        <DrawerForm id="drawer-form-brand"
          title={(createModal ? "Create Brand" : "Edit Brand")}
          buttonText={(createModal ? "Create Brand" : "Update Brand")}
          onClose={() => {
            createModalSet(false)
            editModalSet(false)
            selectedItemSet(undefined)
          }}
          focusOn="txt-brand-name"
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-add-brand", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryBrands, {
              ...body,
              id: selectedItem?.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess(`Brand has been ${(createModal ? "added" : "updated")} successfully!`);
              }
              if (callback) callback(res);
            })

          }}>

          <div className="mb-5">
            <AvatarUploade preventCrop type="brands" name="logo"
              defaultValue={selectedItem?.logo} imageUrl={selectedItem?.logoUrl} />
          </div>

          <TextBox id="txt-brand-name" name="name" label="Name" marginBottom={5}
            labelUp block value={selectedItem?.name} />

          <DropDown id="txt-brand-vendors" name="vendorId"
            label="Vendor" labelUp block forceSelectValue={selectedItem?.vendorId}
            apiSource={`${API_ROUTES.InventoryVendors}all`} />

          <TextArea id="txt-brand-descr" name="description"
            label="Description" labelUp block rows={6} value={selectedItem?.description}
            placeholder="Write a description (optional)" />


        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-brand"
          title="Delete Brand"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onOpen={() => {
            // hub.Post(API_ROUTES.InventoryCategories + "verifydelete", {
            //   id: selectedItem.id
            // }, res => deleteResSet(res.data))
          }}
          onClose={() => {
            deleteModalSet(false)
            //deleteResSet(undefined)
            selectedItemSet(undefined)
          }}
          onSubmit={deleteRes ? (body, callback) => {

            hub.Post(API_ROUTES.InventoryBrands + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Brand has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          } : undefined}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the brand?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
